import React from "react";
import TermsList from "../components/TermsList";
import { TermsDocId } from "../types/terms";

const TermsOfUse: React.FC = () => (
  <TermsList id={TermsDocId.TERMS_OF_USE} title="Termos de Uso" />
);

export default TermsOfUse;
